export default "__VITE_ASSET__B8Cio7_h__"